var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-controller',{attrs:{"receive":_vm.allProps.receive,"all":_vm.allProps.result,"loading":_vm.allProps.loading,"allAdditional":_vm.additionalProps.result,"additionalResource":_vm.additionalResource,"pagination":_vm.pagination,"totalItems":_vm.totalItems,"value":_vm.value,"label":_vm.label},on:{"input":_vm.handleFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }